import { render } from "./NavSubItem.vue?vue&type=template&id=3fbe8f68&scoped=true&ts=true"
import script from "./NavSubItem.vue?vue&type=script&lang=ts"
export * from "./NavSubItem.vue?vue&type=script&lang=ts"

import "./NavSubItem.vue?vue&type=style&index=0&id=3fbe8f68&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbe8f68"]])

export default __exports__